import saleOutboundChains from './modules';

export default [...saleOutboundChains];
